export type Optional<T> = T | undefined;
export const None = undefined;
